module.exports = __webpack_public_path__ + "static/mapAsia-1283cf7086b59e7188f93f73cd2aa7dd.svg";